import type { SessionDataWithGraphQL } from "owa-graph-schema";
import type { MailboxInfo } from "owa-client-types";
import { lazyApplyTombstonesToSessionData } from "owa-offline-session-data";
import type { SessionData } from "owa-service/lib/types/SessionData";

// async to not throw to the main thread if bootstrap fails
export async function applyTombstonesToSessionData(networkSD: SessionData, databaseId: string, mailboxInfo: MailboxInfo): Promise<SessionDataWithGraphQL> {
    return lazyApplyTombstonesToSessionData.importAndExecute(networkSD, databaseId, mailboxInfo);
}
